import { PartialTranslation } from '../translations';

export const sw: PartialTranslation = {
  newChat: 'Mazungumzo Mapya',
  search: 'Tafuta',
  user: 'Mtumiaji',
  settings: 'Mipangilio',
  language: 'Lugha',
  getHelp: 'Pata msaada',
  viewAllPlans: 'Ona mipango yote',
  learnMore: 'Jifunze zaidi',
  logOut: 'Toka',
  chooseLanguage: 'Bize lingvon',
  chooseYourPreferredLanguage: 'Bize vian preferatan lingvon',
  searchLanguages: 'Serĉi lingvojn...',
  autoDetect: 'Uchunguzi wa Kiotomatiki',
  noLanguagesFound: 'Neniuj lingvoj trovitaj',
  askAnything: 'Uliza chochote',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Binafsi',
  freePlan: 'Mpango wa bure',
  current: 'Nuna',
  close: 'Fermi',
  archive: 'Arkivigi',
  delete: 'Forigi',
  confirmDelete: 'Ĉu vi certas ke vi volas forigi ĉi tiun babilon?',
  confirmArchive: 'Ĉu vi certas ke vi volas arkivigi ĉi tiun babilon?',
  deleteCannotUndo: 'Ĉi tiu ago ne povas esti malfari.',
  archiveCanFind: 'Vi povas trovi ĝin en la arkiva listo post arkivigo.',
  
  // 资源面板
  resources: 'Rasilimali',
  addResource: 'Ongeza rasilimali',
  deleteResource: 'Forigi rimedon',
  noMatchingResourcesFound: 'Neniuj kongruaj rimedoj trovitaj',
  noResourcesAvailable: 'Neniuj rimedoj disponeblaj',
  hideResources: 'Kaŝi rimedojn',
  showResources: 'Montri rimedojn',
  
  // 聊天输入框
  typeMessage: 'Andika ujumbe...',
  thinkingOptions: 'Pensaj opcioj',
  deleteFile: 'Forigi dosieron',
  clearSelection: 'Viŝi selekton',
  addAttachment: 'Ongeza kiambatisho',
  sendMessage: 'Tuma ujumbe',
  
  // 思考模式选项
  deepInsight: 'Profunda kompreno · Surfaca analizo',
  deepInsightDesc: 'Rapida kompreno de ŝlosilaj punktoj',
  deepExploration: 'Profunda esplorado · Ampleksa analizo',
  deepExplorationDesc: 'Multdimensia profunda esplorado',
  deepDeconstruction: 'Profunda malkonstruado · Sistema argumento',
  deepDeconstructionDesc: 'Tavolo post tavolo progresa analizo',
  
  // 写作模式选项
  contractReview: 'Kontrakta revizio · Risko identigo',
  contractReviewDesc: 'Klausola analizo kaj konformeca kontrolo',
  textPolish: 'Teksta poluro · Profesia esprimo',
  textPolishDesc: 'Lingva optimumigo kaj struktura alĝustigo',
  legalDocuments: 'Leĝaj dokumentoj · Norma malneto',
  legalDocumentsDesc: 'Profesia leĝa dokumento skribado',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Ingia',
  register: 'Jisajili',
  welcomeBack: 'Karibu LawHelper',
  loginSubtitle: 'Msaidizi wako wa Utafiti wa Kisheria wa AI',
  continueWithGoogle: 'Endelea na Google',
  continueWithMicrosoft: 'Endelea na Microsoft',
  continueWithWeChat: 'Endelea na WeChat',
  orContinueWith: 'au endelea na',
  emailTab: 'Barua pepe',
  phoneTab: 'Simu',
  emailPlaceholder: 'Ingiza barua pepe yako',
  phonePlaceholder: 'Ingiza nambari ya simu',
  codePlaceholder: 'Ingiza msimbo wa tarakimu 6',
  sending: 'Inatuma...',
  verifying: 'Inathibitisha...',
  verify: 'Thibitisha',
  sendMagicLink: 'Tuma kiungo cha kichawi',
  getVerificationCode: 'Pata msimbo',
  resendCode: 'Tuma msimbo tena',
  resendIn: 'Tuma tena',
  magicLinkSent: 'Kiungo cha kichawi kimetumwa kwa barua pepe yako',
  magicLinkHint: 'Tutatuma kiungo salama kwa barua pepe yako',
  otpSent: 'Msimbo wa uthibitisho umetumwa',
  agreeToTerms: 'Kwa kuendelea, unakubali',
  privacyPolicy: 'Sera ya Faragha',
  termsOfService: 'Masharti ya Huduma',
  and: 'na',
  privacyTitle: 'Faragha yako ni muhimu',
  privacyIntro: 'Tunatumia vidakuzi na teknolojia zinazofanana kutoa uzoefu bora.',
  essentialCookies: 'Vidakuzi muhimu',
  essentialDesc: 'Vinahitajika kwa tovuti kufanya kazi',
  analyticsCookies: 'Vidakuzi vya uchambuzi',
  analyticsDesc: 'Hutusaidia kuboresha huduma',
  marketingCookies: 'Vidakuzi vya masoko',
  marketingDesc: 'Hutumika kwa maudhui ya kibinafsi',
  acceptAll: 'Kubali yote',
  essentialOnly: 'Muhimu tu',
  customize: 'Binafsisha',
  savePreferences: 'Hifadhi mapendeleo',
  back: 'Rudi',
  readPrivacyPolicy: 'Soma sera yetu ya faragha',
  cookiePolicy: 'Sera ya vidakuzi',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Ukaguzi wa AI',
  aiDraft: 'Rasimu ya AI',
  smartAssistant: 'Kiolezo',

  // 知识库搜索
  enableKnowledgeSearch: 'Washa utafutaji',
  knowledgeSearchDesc: 'AI inatafuta kwenye hati zako',
  clickToDisable: 'Zima',
  clickToEnable: 'Washa',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Funga paneli ya rasilimali',
  uploading: 'Inapakia %{fileName}...',
  processing: 'Inachakata %{fileName}...',
  uploadSuccess: '✓ %{fileName} imepakiwa',
  uploadError: '✗ Kupakia kumeshindwa: %{error}',
  quickAnswer: 'Jibu la Haraka',
  quickAnswerDesc: 'Jibu la haraka kwa maswali rahisi',
  cancelRequest: 'Ghairi',
  library: 'Maktaba',
  filterAll: 'Zote',
  filterChat: 'Mazungumzo',
  filterReview: 'Ukaguzi',
  filterDraft: 'Rasimu',
  filterTemplate: 'Kiolezo',
  filterForm: 'Fomu',
  thinking: 'Inafikiria...',
  thinkingProcess: 'Mchakato wa kufikiri',
  analyzingLegalLogic: 'Kuchambua mantiki ya kisheria...',
  lawhelperThinking: 'Lawhelper inafikiria...',
  serviceError: 'Hitilafu ya huduma',
  uploaded: 'Imepakiwa',
  settingsGeneral: 'Jumla',
  settingsNotifications: 'Arifa',
  settingsAppearance: 'Mwonekano',
  settingsProfile: 'Wasifu',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Hali ya rangi',
  settingsLight: 'Angavu',
  settingsDark: 'Giza',
  settingsSystem: 'Mfumo',
  about: 'Kuhusu',
  reviewTitle: 'Ukaguzi wa Hati',
  exitReview: 'Acha ukaguzi',
  uploadPrompt: 'Pakia PDF kwa ukaguzi',
  uploadButton: 'Chagua faili',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Inakagua...',
  reviewComplete: 'Ukaguzi umekamilika',
  issuesFound: 'Matatizo %{count} yamepatikana',
  draftTitle: 'Kuandaa hati ya kisheria',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Inaunda...',
  generatedSuccess: '✅ Hati imeundwa!',
  drafterWelcome: 'Karibu katika Msaidizi wa Hati wa AI',
  drafterYouCan: 'Unaweza:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Mifano:',
  drafterExampleRental: '"Andaa mkataba wa kukodisha"',
  drafterExampleLabor: '"Jaza mkataba wa kazi"',
  drafterInputPlaceholder: 'Eleza mahitaji yako...',
  drafterThinking: 'Inafikiria...',
  drafterHistoryTitle: 'Historia',
  drafterNoHistory: 'Hakuna historia',
  drafterNewChat: 'Mazungumzo mapya',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Hifadhi hati',
  drafterDownload: 'Pakua hati',
  drafterUndo: 'Tendua',
  drafterRedo: 'Rudia',
  drafterBold: 'Nono',
  drafterItalic: 'Italiki',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Toka',
  drafterConfirm: 'Thibitisha',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'Mtiririko wa AI',
  workflowRunning: 'Inaendelea...',
  workflowReady: 'Tayari',
  workflowCompleted: 'Imekamilika',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Kubali mabadiliko',
  rejectChanges: 'Kataa mabadiliko',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Simamisha',
  restartWorkflow: 'Restart',
  startDrafting: 'Anza kuandaa',
  interrupt: 'Stop',
  documentSubject: 'Mada ya hati *',
  documentType: 'Aina ya hati',
  jurisdiction: 'Mamlaka',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Mkataba',
  docTypeAgreement: 'Makubaliano',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Barua',
  docTypePetition: 'Petition',
  docTypeWill: 'Wosia',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'Marekani',
  countryGermany: 'Ujerumani',
  countryJapan: 'Japani',
  countryFrance: 'Ufaransa',
  countryUK: 'Uingereza',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Msaidizi Mzuri wa Hati',
  smartDocChatTitle: 'Msaidizi wa Hati wa AI',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Chagua faili',
  smartDocOr: 'au',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Hitilafu',
  unknownError: 'Hitilafu isiyojulikana',
  file: 'Faili',
  loading: 'Inapakia...',
  localFolders: 'Folda za ndani',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Hifadhi',
  renameFile: 'Badilisha jina',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'Uchambuzi wa AI',
};
